export const AUTH_INFO_AREA = "authInfo";
